import { render, staticRenderFns } from "./payement.vue?vue&type=template&id=14637cdb&scoped=true"
import script from "./payement.vue?vue&type=script&lang=js"
export * from "./payement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14637cdb",
  null
  
)

export default component.exports